import Anchor from './components/Anchor';
import { AnchorLink } from './components/AnchorLink';
Anchor.Link = AnchorLink;
export { Anchor };